import { useState } from 'react'
import { ServerCrash, RefreshCw, Mail, ChevronDown, ChevronUp, Copy, Check } from 'lucide-react'

export default function ErrorScreen({ error, componentStack, resetError }) {
  const [showDetails, setShowDetails] = useState(false)
  const [copied, setCopied] = useState(false)

  const handleRetry = () => {
    if (resetError) {
      resetError()
    } else {
      window.location.reload()
    }
  }

  const debugText = [
    `Error: ${error?.message ?? 'unknown'}`,
    error?.stack ? `\nStack:\n${error.stack}` : '',
    componentStack ? `\nComponent stack:${componentStack}` : '',
  ].join('')

  const handleCopy = () => {
    navigator.clipboard.writeText(debugText).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg w-full text-center">
        <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <ServerCrash className="h-10 w-10 text-orange-500" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Что-то пошло не так
        </h1>

        <p className="text-gray-600 mb-6">
          Произошла ошибка при загрузке данных. Попробуйте обновить страницу или вернитесь позже.
        </p>

        {error?.message && (
          <div className="mb-4 p-3 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 font-mono break-all">
              {error.message}
            </p>
          </div>
        )}

        {(error?.stack || componentStack) && (
          <div className="mb-6 text-left">
            <button
              onClick={() => setShowDetails(v => !v)}
              className="flex items-center gap-1 text-sm text-gray-400 hover:text-gray-600 transition-colors mx-auto"
            >
              {showDetails ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              Технические детали
            </button>

            {showDetails && (
              <div className="mt-2 relative">
                <pre className="text-xs text-gray-500 bg-gray-50 rounded-lg p-3 overflow-auto max-h-48 whitespace-pre-wrap break-all">
                  {debugText}
                </pre>
                <button
                  onClick={handleCopy}
                  className="absolute top-2 right-2 p-1.5 rounded bg-white border border-gray-200 hover:bg-gray-50 transition-colors"
                  title="Скопировать"
                >
                  {copied ? <Check className="h-3.5 w-3.5 text-green-500" /> : <Copy className="h-3.5 w-3.5 text-gray-400" />}
                </button>
              </div>
            )}
          </div>
        )}

        <button
          onClick={handleRetry}
          className="inline-flex items-center justify-center space-x-2 w-full px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          <RefreshCw className="h-5 w-5" />
          <span>Попробовать снова</span>
        </button>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-3">
            Если проблема повторяется, напишите нам:
          </p>
          <a
            href="mailto:support@zionhub.ru?subject=Ошибка в WMS MVP&body=Опишите проблему..."
            className="inline-flex items-center justify-center space-x-2 text-blue-600 hover:underline"
          >
            <Mail className="h-4 w-4" />
            <span>support@zionhub.ru</span>
          </a>
        </div>
      </div>
    </div>
  )
}
